"use strict";
var infiniteLoads = 0;
function pagination(){
    document.querySelectorAll(".load-more").forEach((btn) => {
      btn.classList.remove('loading');
      var url = btn.getAttribute('href');
      if (btn.classList.contains("infinite")){
        var maxLoads = parseInt(btn.dataset.maxLoads || '0', 10);
        if(maxLoads > 0 && infiniteLoads >= maxLoads){
          // Hand off to a manual button after N automatic loads so the footer stays reachable
          btn.classList.remove('infinite');
          btn.classList.add('btn');
          btn.innerHTML = '<span class="txt">' + (btn.dataset.moreLabel || 'Load more') + '</span><div class="loading__spinner"><svg class="at-icon at-spin"><use xlink:href="#icon-loading"></use></svg></div>';
          btn.addEventListener("click",(e) => {
              e.preventDefault();
              btn.classList.add('loading');
              infiniteLoads = 0;
              loadMoreproducts(url);
            },
            false
          );
          return;
        }
        var observer = new IntersectionObserver(
          function(entries){
            entries.forEach((entry) => {
              if (entry.isIntersecting && !btn.classList.contains('loading')){
                btn.classList.add('loading');
                infiniteLoads++;
                loadMoreproducts(url);
              }
            });
          },
          { rootMargin: '0px 0px 200px 0px' }
        );
        observer.observe(btn);
      } else {
        btn.addEventListener("click",(e) => {
            e.preventDefault();
            btn.classList.add('loading');
            loadMoreproducts(url);
          },
          false
        );
      }
    });
}
pagination();
function loadMoreproducts(url){
    // Fetch only this section instead of the whole page — same markup, a fraction of the payload
    const paginationWrap = document.getElementById('pagination');
    const sectionId = paginationWrap ? paginationWrap.dataset.id : null;
    const fetchUrl = sectionId ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sectionId : url;
    fetch(fetchUrl).then((response) => response.text()).then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html'),
        products = document.getElementById('collection-products'),
        productsSource = html.querySelector('#collection-products'),
        paginationEl = document.getElementById('pagination'),
        paginationSource = html.querySelector('#pagination');

      if(products && productsSource) products.insertAdjacentHTML('beforeend', productsSource.innerHTML);
      if(paginationEl && paginationSource) {
        paginationEl.innerHTML = paginationSource.innerHTML;
      } else if (paginationEl) {
        paginationEl.innerHTML = '';
      }
    })
    .finally(() => {
      pagination();
      if(theme.mlcurrency) currenciesChange(document.querySelectorAll('product-card span.money'));
      initializeVideos();initBgimages();
      initializeScrollAnimationTrigger();
    })
    .catch((e) => {
      console.error(e);
    });
}

class FiltersForm extends HTMLElement {
  constructor() {
      super();
      var _this = this,
        fbtns = document.querySelectorAll(".btn-filter"),
        topFilters = document.querySelector(".filter-horizontal");

      this.secId = this.dataset.id;
      this.mql = window.matchMedia('(min-width: 767px)');
  
      fbtns.forEach((btn) =>
        btn.addEventListener('click', this.mobileFilters.bind(this))
      );
      if(topFilters && this.mql.matches === true) this.blockToggle();
      this.selectFilters();
      this.priceRangeSlider();
      this.removeFilters();
      this.selectSort();

      // Back/forward must restore the filtered state the URL describes
      this._onPopState = () => {
        const search = window.location.search.replace(/^\?/, '');
        this.renderSectionFromFetch(search, false, true);
      };
      window.addEventListener('popstate', this._onPopState);

      // Filters apply live — the drawer's "Show N results" button just closes it
      this.addEventListener('click', (e) => {
        if(!e.target.closest('.applyFilters')) return;
        document.documentElement.classList.remove('activ-filter','show-overly');
      });

      this.addEventListener('change', function(e){
        if (!e.target.classList.contains('optTag')) return;

        var URL = _this.dataset.url,
            paramString = new URLSearchParams(window.location.search),
            productFilters = document.querySelectorAll('input.optTag'),
            newTags = [],
            bytags = true;

        productFilters.forEach(function(el){
            if(el.value && el.checked){
                newTags.push(el.value);
            }
        });

        if (newTags.length) {
            var tags = newTags.join('+');
            _this.renderSectionFromFetch(URL + '/' + tags + '?' + paramString, bytags);
        } else {
            _this.renderSectionFromFetch(URL + '?' + paramString, bytags);
        }
      });

  }
  selectSort(){
    var shortby = document.getElementById('sort-by');
    if(!shortby) return;
    shortby.addEventListener('change', this.onFormSubmit.bind(this));
  }
  selectFilters(){
    var filters = this.querySelectorAll('input.dyfl, .price-range');
    filters.forEach((filter) =>
       filter.addEventListener('change', this.onFormSubmit.bind(this))
    );
  }
  priceRangeSlider(){
    const priceSlider = document.getElementById('priceSlider');
    if(!priceSlider) return;
    const min = document.getElementById('Filter-Price-GTE'),
      max = document.getElementById('Filter-Price-LTE'),
      minDisplay = document.querySelector('[data-price-display="min"]'),
      maxDisplay = document.querySelector('[data-price-display="max"]');

    const formatPrice = (value) => {
      const cents = Math.round(value) * 100;
      if (window.theme && theme.Currency && theme.Currency.formatMoney) {
        return theme.Currency.formatMoney(cents, theme.moneyFormat);
      }
      return Math.round(value).toLocaleString();
    };

    // Only user interaction may arm the filter — tc-range-slider fires change on mount too
    const markDirty = () => { this._priceDirty = true; };
    priceSlider.addEventListener('pointerdown', markDirty);
    priceSlider.addEventListener('keydown', markDirty);

    priceSlider.addEventListener('change', (evt) => {
      const v1 = Math.round(evt.detail.value1);
      const v2 = Math.round(evt.detail.value2);
      if (minDisplay) minDisplay.textContent = formatPrice(v1);
      if (maxDisplay) maxDisplay.textContent = formatPrice(v2);
      if (!this._priceDirty) return;
      const changed = min.value !== v1.toString() || max.value !== v2.toString();
      min.value = v1.toString();
      max.value = v2.toString();
      if (!changed) return;
      // Debounced submit — works for mouse, touch and keyboard alike
      clearTimeout(this._priceTimer);
      this._priceTimer = setTimeout(() => min.dispatchEvent(new Event('change')), 500);
    });
  }
  onFormSubmit(e){
    const flForm = this.querySelector('form'),
      formData = new FormData(flForm),
      params = new URLSearchParams(formData);
      this.renderSectionFromFetch(params);
  }
  renderSectionFromFetch(params, tags, skipHistory){
    var url = `${window.location.pathname}?section_id=${this.secId}&${params.toString()}`
    if(tags){
        url = `${params}&section_id=${this.secId}`
    }

    // Cancel any in-flight render so rapid clicks can't resolve out of order
    if(this._activeFetch) this._activeFetch.abort();
    const controller = new AbortController();
    this._activeFetch = controller;

    document.body.classList.add('load-filters');
    fetch(url, { signal: controller.signal }).then((response) => response.text()).then((responseText) => {
        if(this._activeFetch !== controller) return;
        const html = new DOMParser().parseFromString(responseText, 'text/html'),
          products = document.getElementById('collection-products'),
          filters = this.querySelector('.filters-item__wrapper'),
          counts = document.getElementById('itemsCount'),
          paginationEl = document.getElementById('pagination'),
          paginationSource =  html.querySelector('#pagination'),
          activeFilters =  document.getElementById('active-filters');

        if(counts && html.querySelector('#itemsCount')) counts.innerHTML = html.querySelector('#itemsCount').innerHTML;
        if(activeFilters && html.querySelector('#active-filters')) activeFilters.innerHTML = html.querySelector('#active-filters').innerHTML;
        var applyCount = document.getElementById('applyCount');
        if(applyCount && html.querySelector('#applyCount')) applyCount.innerHTML = html.querySelector('#applyCount').innerHTML;
        var flCount = document.getElementById('flCount');
        if(flCount && html.querySelector('#flCount')) flCount.innerHTML = html.querySelector('#flCount').innerHTML;
        if(products && html.querySelector('#collection-products')) products.innerHTML = html.querySelector('#collection-products').innerHTML;
        if(filters && html.querySelector('.filters-item__wrapper')) filters.innerHTML = html.querySelector('.filters-item__wrapper').innerHTML;
        if(paginationEl && paginationSource) {
          paginationEl.innerHTML = paginationSource.innerHTML;
        } else if(paginationEl) {
          paginationEl.innerHTML = ' ';
        }

        if(!skipHistory){
          var newUrl = tags ? `${params.toString()}` : `${window.location.pathname}?${params.toString()}`;
          history.pushState({ page: newUrl }, '', newUrl);
        }
        // Keep the sort select honest after back/forward restores
        var sortSel = document.getElementById('sort-by');
        if(sortSel){
          var sortVal = new URLSearchParams(window.location.search).get('sort_by') || sortSel.dataset.default;
          if(sortVal) sortSel.value = sortVal;
        }
        infiniteLoads = 0;
        this.selectFilters();this.priceRangeSlider();this.removeFilters();pagination();
        if(theme.mlcurrency) currenciesChange(document.querySelectorAll('product-card span.money'));
        initializeVideos();initBgimages();
        initializeScrollAnimationTrigger();
        // If the user filtered from deep in the page, bring the (new) results into view.
        // Skipped on popstate — the browser restores its own scroll position there.
        if(!skipHistory){
          var grid = document.getElementById('collection-products');
          if(grid){
            var gridTop = grid.getBoundingClientRect().top;
            if(gridTop < 0){
              var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
              window.scrollTo({ top: gridTop + window.scrollY - 120, behavior: reduceMotion ? 'auto' : 'smooth' });
            }
          }
        }
      })
      .catch((e) => {
        if(e && e.name === 'AbortError') return;
        console.error(e);
      })
      .finally(() => {
        if(this._activeFetch === controller){
          this._activeFetch = null;
          document.body.classList.remove('load-filters');
        }
      });
  }
  removeFilters(){
    var _this = this,
        activeFl = document.querySelectorAll(".active-fl, .js-facet-clear");
    activeFl.forEach((btn) => {
        btn.addEventListener("click",(e) => {
          e.preventDefault();
          var params = btn.getAttribute('href').split('?')[1] || '';
          _this.renderSectionFromFetch(params);
        })
      });
  }
  mobileFilters(){
    var html = document.documentElement;
    html.classList.add('activ-filter','show-overly');
    if(this.dataset.collapse !== 'true'){
      this.querySelectorAll('.filters-item').forEach((blk) => {
        blk.open = true;
      });
    }
    document.querySelector(".closeFilter").addEventListener('click', function(e){
        html.classList.remove('activ-filter','show-overly');
    });
  }
  blockToggle(){
      const body = document.body,
        filters = document.querySelectorAll(".filter-horizontal .filters-title"),
        blocks = this.querySelectorAll('.filters-item');
      filters.forEach((blk) => {
        const act = blk.closest('.filters-item[open]');
        blocks.forEach((other) => {
           if(other !== act){
             other.removeAttribute('open');
           }
        });
      });
      body.addEventListener('click', function(e){
          blocks.forEach((blk) => {
            if(e.target.closest('.filters-item[open]')) return;
             blk.removeAttribute('open');
        });
      });
  }
}
customElements.define("filters-form", FiltersForm);

// "Show more" toggle for long filter value lists — delegated so it survives AJAX re-renders
document.addEventListener('click', function(e){
  var more = e.target.closest('.fl-more');
  if(!more) return;
  var wrap = more.closest('.filters-select');
  if(!wrap) return;
  var expanded = wrap.classList.toggle('fl-expanded');
  more.setAttribute('aria-expanded', expanded);
  more.textContent = expanded ? more.dataset.less : more.dataset.more;
});

// Search box inside large filters — plain text match on the value labels
document.addEventListener('input', function(e){
  var inp = e.target.closest('.fl-search');
  if(!inp) return;
  var wrap = inp.closest('.filters-select');
  if(!wrap) return;
  var q = inp.value.trim().toLowerCase();
  wrap.classList.toggle('fl-searching', q.length > 0);
  wrap.querySelectorAll('.filters-select__list > li').forEach(function(li){
    li.classList.toggle('fl-hide', q.length > 0 && li.textContent.toLowerCase().indexOf(q) === -1);
  });
});
document.addEventListener('keydown', function(e){
  if(e.key === 'Enter' && e.target.closest('.fl-search')) e.preventDefault();
});

if(!customElements.get('clamp-text')){
  customElements.define('clamp-text', class ClampText extends HTMLElement {
    connectedCallback(){
      this.rte = this.querySelector('.clamp-rte');
      this.btn = this.querySelector('.clamp-toggle');
      if(!this.rte || !this.btn) return;
      // Reveal the toggle only when the text actually overflows its clamp
      const check = () => {
        if(!this.classList.contains('expanded') && this.rte.scrollHeight > this.rte.clientHeight + 1){
          this.btn.classList.remove('hidden');
        }
      };
      check();
      requestAnimationFrame(check);
      this.btn.addEventListener('click', () => {
        const expanded = this.classList.toggle('expanded');
        this.btn.setAttribute('aria-expanded', expanded);
        this.btn.textContent = expanded ? this.btn.dataset.less : this.btn.dataset.more;
      });
    }
  });
}

document.querySelectorAll(".change-view").forEach((btn) => {
  btn.addEventListener("click",(e) => {
     e.preventDefault();
      var view = btn.dataset.view,
        href = new URL(window.location.href);
      try { localStorage.setItem('at_view', view); } catch(err) {}
      href.searchParams.set("type", view);
      window.location = href.toString();
  });
});

// Remember the shopper's grid/list choice across collections.
// An explicit ?type= in the URL always wins; list is the only non-default worth restoring.
(function(){
  if(window.Shopify && Shopify.designMode) return; // never auto-redirect inside the theme editor — it fights the editor's preview URL handling and loops
  if(!document.querySelector('.change-view')) return;
  var url = new URL(window.location.href);
  if(url.searchParams.has('type')) return;
  try {
    if(localStorage.getItem('at_view') === 'list'){
      url.searchParams.set('type', 'list');
      window.location.replace(url.toString());
    }
  } catch(err) {}
})();